module.exports = __webpack_public_path__ + "static/servers.d81a0ab0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/data/screenshots/witsbits/servers.jpg
// module id = ./src/app/data/screenshots/witsbits/servers.jpg
// module chunks = 4